import { JSX } from 'react'

import { IconProps } from '../../icon'

const EdubookLandscapeBlack: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 35}
    id={id}
    stroke={stroke}
    viewBox='0 0 111 35'
    width={width || 111}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M79.6198 35L56.256 29.6091L57.2121 26.3136L80.576 31.6943L79.6198 35Z'
      fill='black'
    />
    <path
      d='M79.5791 35L102.943 29.6091L101.987 26.3136L78.623 31.6943L79.5791 35Z'
      fill='black'
    />
    <path
      d='M4.21875 3.61087H13.963L13.4036 0.742523H0.140015V3.61087H4.21875Z'
      fill='black'
    />
    <path
      d='M11.0642 11.6666L10.4742 8.76779H4.21875H0.140015V11.6666H4.21875H11.0642Z'
      fill='black'
    />
    <path
      d='M13.4036 17.0474H4.21875H0.140015V19.8852H13.9935L13.4036 17.0474Z'
      fill='black'
    />
    <path
      d='M28.8337 19.8852H26.9215L26.0772 18.6443C24.877 19.6919 23.5649 20.2209 22.1307 20.2209C20.0049 20.2209 18.3367 19.5801 17.106 18.2883C15.8753 17.0067 15.265 15.2572 15.265 13.0602C15.265 11.6362 15.5396 10.3749 16.099 9.28654C16.6483 8.1982 17.4518 7.35396 18.5097 6.75384C19.5573 6.15373 20.8084 5.84858 22.2528 5.84858C22.7003 5.84858 23.1784 5.92996 23.6869 6.0927C24.1955 6.25545 24.6837 6.46904 25.1516 6.75384V0.305139L28.8439 0V19.875L28.8337 19.8852ZM22.2731 17.0982C22.7613 17.0982 23.2394 17.0067 23.6971 16.8134C24.1548 16.6303 24.6431 16.3455 25.1516 15.9692V10.1409C24.6634 9.72391 24.1955 9.42894 23.748 9.25603C23.3004 9.07294 22.8122 8.99158 22.2833 8.99158C21.2865 8.99158 20.5033 9.36792 19.9133 10.1308C19.3336 10.8936 19.0386 11.8701 19.0386 13.0703C19.0386 14.2706 19.3234 15.247 19.893 15.9895C20.4626 16.732 21.2559 17.0982 22.2731 17.0982Z'
      fill='black'
    />
    <path
      d='M37.7338 17.2915C38.3746 17.2915 38.9746 17.1491 39.5341 16.8541C40.0935 16.5591 40.714 16.1726 41.3955 15.6844V6.22495H45.0572V19.8852H42.6669L42.0465 18.4205C41.2022 19.0206 40.2969 19.4885 39.3408 19.8242C38.3847 20.1598 37.5303 20.3328 36.7776 20.3328C35.0485 20.3328 33.8381 19.8445 33.1464 18.8681C32.4547 17.8916 32.1089 16.5286 32.1089 14.7893V6.22495H35.7706V14.6164C35.7706 15.4606 35.9435 16.1218 36.2894 16.5897C36.6352 17.0576 37.1234 17.2915 37.7439 17.2915H37.7338Z'
      fill='black'
    />
    <path
      d='M72.3066 20.2209C70.8419 20.2209 69.5602 19.9259 68.4617 19.3461C67.3632 18.7663 66.5189 17.9323 65.9087 16.8541C65.3085 15.7759 65.0034 14.5147 65.0034 13.0703C65.0034 11.626 65.2984 10.3545 65.9087 9.2662C66.5088 8.17785 67.3632 7.33362 68.4617 6.74368C69.5602 6.15373 70.8419 5.85876 72.3066 5.85876C73.7712 5.85876 75.0528 6.15374 76.1513 6.73351C77.2499 7.31328 78.0941 8.14734 78.7044 9.22552C79.3045 10.3037 79.6097 11.565 79.6097 13.0093C79.6097 14.4536 79.3045 15.7251 78.7044 16.8134C78.1043 17.9018 77.2499 18.746 76.1513 19.336C75.0528 19.9259 73.7712 20.2209 72.3066 20.2209ZM75.8258 13.0093C75.8258 11.8294 75.5004 10.8631 74.8392 10.1104C74.1781 9.35774 73.3339 8.9814 72.3066 8.9814C71.2792 8.9814 70.4553 9.36792 69.784 10.1308C69.1127 10.9038 68.7872 11.8803 68.7872 13.0602C68.7872 14.2401 69.1127 15.2063 69.7739 15.959C70.435 16.7117 71.2792 17.0881 72.3066 17.0881C73.3339 17.0881 74.1577 16.7015 74.8291 15.9285C75.4902 15.1555 75.8258 14.179 75.8258 12.9991V13.0093Z'
      fill='black'
    />
    <path
      d='M88.3062 20.2209C86.8416 20.2209 85.5599 19.9259 84.4614 19.3461C83.3629 18.7663 82.5187 17.9323 81.9084 16.8541C81.3083 15.7759 81.0031 14.5147 81.0031 13.0703C81.0031 11.626 81.2981 10.3545 81.9084 9.2662C82.5085 8.17785 83.3629 7.33362 84.4614 6.74368C85.5599 6.15373 86.8416 5.85876 88.3062 5.85876C89.7709 5.85876 91.0526 6.15374 92.1511 6.73351C93.2496 7.31328 94.0938 8.14734 94.7041 9.22552C95.3042 10.3037 95.6094 11.565 95.6094 13.0093C95.6094 14.4536 95.3042 15.7251 94.7041 16.8134C94.104 17.9018 93.2496 18.746 92.1511 19.336C91.0526 19.9259 89.7709 20.2209 88.3062 20.2209ZM91.8256 13.0093C91.8256 11.8294 91.5001 10.8631 90.8389 10.1104C90.1778 9.35774 89.3336 8.9814 88.3062 8.9814C87.2789 8.9814 86.4551 9.36792 85.7837 10.1308C85.1124 10.9038 84.7869 11.8803 84.7869 13.0602C84.7869 14.2401 85.1124 15.2063 85.7736 15.959C86.4347 16.7117 87.2789 17.0881 88.3062 17.0881C89.3336 17.0881 90.1574 16.7015 90.8287 15.9285C91.4899 15.1555 91.8256 14.179 91.8256 12.9991V13.0093Z'
      fill='black'
    />
    <path
      d='M101.316 15.4098V19.8852H97.6843V0.315332L101.316 0.0101929V11.2191L107.174 5.83844L109.229 8.43216L105.404 11.7786L110.419 19.8852H106.218L102.78 14.1078L101.316 15.3996V15.4098Z'
      fill='black'
    />
    <path
      d='M60.65 9.50015C62.0232 8.43215 62.7047 7.29294 62.7047 6.09271C62.7047 4.25167 62.1554 2.89886 61.0467 2.03429C59.938 1.16971 58.4021 0.742523 56.4289 0.742523H48.9935V3.78378H55.8898C56.8663 3.78378 57.5986 3.96687 58.097 4.32287C58.5954 4.67887 58.8395 5.28916 58.8395 6.15373C58.8395 6.94711 58.5242 7.53706 57.8834 7.94392C57.2426 8.35078 56.3882 8.5542 55.3202 8.5542H48.9834V11.5141H56.8154C57.7308 11.5141 58.4632 11.7582 59.0023 12.2464C59.5414 12.7347 59.8058 13.4162 59.8058 14.3011C59.8058 15.125 59.5108 15.7658 58.9311 16.2133C58.3513 16.6609 57.5579 16.8846 56.5611 16.8846H48.9834V19.8954H56.8357C58.9005 19.8954 60.5382 19.397 61.7588 18.39C62.9793 17.383 63.5896 16.0099 63.5896 14.2604C63.5896 12.1244 62.6029 10.5376 60.6297 9.50015H60.65Z'
      fill='black'
    />
  </svg>
)

export default EdubookLandscapeBlack
